import ParticipantUser from './ParticipantUser';

export default ParticipantUser;
